import { blobToDataURL } from './blobToDataURL';
import { MediaProportions } from '../models/graphql';
import { getMediaProportion } from './media';

export type ImagePreviewResponse = {
  preview: string;
  proportion: MediaProportions;
  width: number;
  height: number;
  length: number | null;
};
export const getVideoCover = (
  file: File,
  seekTo = 0.0,
  thumbnailSize = 320,
  imageQuality = 1
): Promise<ImagePreviewResponse> =>
  new Promise<ImagePreviewResponse>((resolve, reject) => {
    const videoPlayer = document.createElement('video');
    videoPlayer.setAttribute('src', URL.createObjectURL(file));
    videoPlayer.load();
    videoPlayer.addEventListener('error', ex => {
      reject(ex.message);
    });
    // load metadata of the video to get video duration and dimensions
    videoPlayer.addEventListener('loadedmetadata', () => {
      // seek to user defined timestamp (in seconds) if possible
      if (videoPlayer.duration < seekTo) {
        // video is shorter than seekTo input, take the last frame then
        seekTo = videoPlayer.duration;
      }
      // delay seeking or else 'seeked' event won't fire on Safari
      setTimeout(() => {
        videoPlayer.currentTime = seekTo;
      }, 200);
      // extract video thumbnail once seeking is complete
      videoPlayer.addEventListener('seeked', () => {
        // define a canvas to have the same dimension as the video
        const canvas = document.createElement('canvas');
        const smallestSize = Math.min(videoPlayer.videoWidth, videoPlayer.videoHeight);
        const resizerRatio = thumbnailSize / smallestSize;
        const canvasX = Math.ceil(videoPlayer.videoWidth * resizerRatio);
        const canvasY = Math.ceil(videoPlayer.videoHeight * resizerRatio);
        canvas.width = canvasX;
        canvas.height = canvasY;
        const proportion = getMediaProportion(videoPlayer.videoWidth, videoPlayer.videoHeight);
        // draw the video frame to canvas
        const ctx = canvas.getContext('2d');
        if (!ctx) reject('Could not get canvas 2d context');
        if (ctx) {
          ctx.drawImage(videoPlayer, 0, 0, canvasX, canvasY);
          ctx.canvas.toBlob(
            blob => {
              if (blob) {
                blobToDataURL(blob)
                  .then(result =>
                    resolve({
                      preview: result,
                      proportion,
                      width: videoPlayer.videoWidth,
                      height: videoPlayer.videoHeight,
                      length: videoPlayer.duration
                    })
                  )
                  .catch(e => reject(e));
              } else {
                reject('Canvas to Blob failed');
              }
            },
            'image/jpeg',
            imageQuality
          );
          resolve({
            preview: ctx.canvas.toDataURL(),
            proportion,
            width: videoPlayer.videoWidth,
            height: videoPlayer.videoHeight,
            length: videoPlayer.duration
          });
        }
      });
    });
  });
